<template>
    <div class="flex wrap gap-1 align-start"> 
        <label>
            Date:
            <input v-model="date" type="text" :disabled="disabled" placeholder="MM/DD/YYYY" @blur="formatDate" />
        </label>
        <label>
            Time:
            <input v-model="time" type="text" :disabled="disabled" placeholder="HH:MM AM/PM" @blur="formatTime" />
            (based on Eastern Time Zone)
        </label>
    </div>
</template>

<script>
import momentTz from 'moment-timezone';

export default {
    name: 'date-time-input',
    props: {
        value: {
            required: false
        },
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
    },
    data() {
        return {
            date: null,
            time: null
        }
    },
    created() {
        momentTz.tz.setDefault("America/New_York");
        if (this.value) {
            const dateTime = momentTz.utc(this.value)
            this.date = dateTime.format('MM/DD/YYYY')
            this.time = dateTime.format('hh:mm A')
        }
    },
    methods: {
        formatDate() {
            if (!this.date) return
            const date = momentTz(this.date, 'MM/DD/YYYY')
            if (date.isValid()) {
                this.date = date.format('MM/DD/YYYY')
                this.emitValue()
            } else {
                this.date = null
                this.emitValue()
            }
        },
        formatTime() {
            if (!this.time) return
            const time = momentTz(this.time, 'hh:mm A')
            if (time.isValid()) {
                this.time = time.format('hh:mm A')
                this.emitValue()
            } else {
                this.time = null
                this.emitValue()
            }
        },
        emitValue() {
            if (this.date && this.time) {
                const dateTime = momentTz.utc(`${this.date} ${this.time}`, 'MM/DD/YYYY hh:mm A')
                if (dateTime.isValid()) {
                    this.$emit('input', dateTime)
                } else {
                    this.$emit('input', null)
                }
            } else {
                this.$emit('input', null)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
label {
    width: 48%;
}
</style>